import { Component, OnInit } from '@angular/core';
import { FamilyRegistrationService } from '../family-registration.service';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';
import { UserService } from '../../../shared-components/user/user.service';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: [
      './select-language.component.css',
      '../familiy-registration-shared-style.css'
    ]
})
export class SelectLanguageComponent implements OnInit {

  LoginSettings: LoginSettings;
  registerNewFamily: any;
  isV10: boolean;

  constructor(
    private userService: UserService,
    private familyRegistrationService: FamilyRegistrationService,
    private loginService: LoginService,
    private dialogRef: MatDialogRef<SelectLanguageComponent>,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.registerNewFamily = this.familyRegistrationService.registerNewFamily;
    this.LoginSettings = this.loginService.LoginSettings;
    this.isV10 = this.LoginSettings.V10;
  }

  modalInstanceNextClick = function () {

    this.userService.currentLanguage = this.registerNewFamily.language;
    this.translateService.use(this.userService.currentLanguage);
    this.translateService.setDefaultLang(this.userService.currentLanguage);

    this.registerNewFamily.languageId = 1;
    if (this.userService.currentLanguage == 'fr') {
        this.registerNewFamily.languageId = 2;
    }
    else if (this.userService.currentLanguage == 'es') {
        this.registerNewFamily.languageId = 3;
    }
    else if (this.userService.currentLanguage == 'pt') {
        this.registerNewFamily.languageId = 4;
    }

    this.dialogRef.close('Register New Family Message');
};

modalInstanceCancelClick = function () {
    this.dialogRef.close('Cancel was clicked.');
};
}
